import IconComponent from "icons/IconComponent";

import ClockNine from "./clock-nine.svg";

export default (ClockNine as any) as IconComponent;
